import TextInput from "~/shared/form/TextInput";
import SelectInput from "~/shared/form/SelectInput";
import { CONTACT_TYPES, FAMILY_CONTACT_TYPES, US_STATES } from "./form-constants";

export function AddressFields(props) {
    return (
        <>
            <TextInput label="Street Address" id="streetAddress" flex={2} minWidth={16} required {...props} />
            <TextInput label="Apt #" id="aptNumber" flex={0} minWidth={5} {...props} />
            <TextInput label="City" id="city" minWidth={10} required {...props} />
            <SelectInput label="State" id="state" flex={0} minWidth={6} placeholder="-" options={US_STATES} required {...props} />
            <TextInput label="ZIP Code" id="zipcode" minWidth={6} maxWidth={7} mask="99999" minLength={5} invalid="5 digit ZIP code required." required {...props} />
        </>
    );
}

export function FullNameFields(props) {
    return (
        <>
            <TextInput label="First Name" id="firstName" minWidth={12} required {...props} />
            <TextInput label="Middle Name" id="middleName" minWidth={12} {...props} />
            <TextInput label="Last Name" id="lastName" minWidth={12} required {...props} />
        </>
    );
}

export function EmergencyContactFields({ family = false, prefix = "emergency", ...props }) {
    return (
        <>
            <TextInput label="Full Name" id={`${prefix}ContactName`} flex={1.5} minWidth={8} required {...props} />
            <TextInput label="Phone Number" id={`${prefix}ContactPhone`} preset="phone" required {...props} />
            <SelectInput label="Relationship" id={`${prefix}ContactRelationship`} placeholder="Select relationship" options={family ? FAMILY_CONTACT_TYPES : CONTACT_TYPES} required {...props} />
        </>
    );
}